// src/hooks/useAuthGuard.ts
//
// Hook de verificação de login para rotas protegidas.
//
// Uso no Browser.tsx (ou qualquer componente de rota protegida):
//
//   const { autenticado, carregando } = useAuthGuard();
//   if (carregando) return <SplashScreen />;
//   // se não autenticado o hook já redireciona para /login

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import tokenService from '../../../services/tokenservice';

interface AuthGuardResult {
    carregando: boolean;
    autenticado: boolean;
    usuario: Record<string, any>;
}

function useAuthGuard(redirecionar = '/login'): AuthGuardResult {
    const navigate = useNavigate();

    const [carregando, setCarregando]   = useState(true);
    const [autenticado, setAutenticado] = useState(false);
    const [usuario, setUsuario]         = useState<Record<string, any>>({});

    useEffect(() => {
        let cancelado = false;

        const verificar = async () => {
            try {
                const token = await tokenService.getToken();

                if (!token) {
                    if (!cancelado) navigate(redirecionar, { replace: true });
                    return;
                }

                const dadosUsuario = await tokenService.getUsuario();

                if (!dadosUsuario) {
                    await tokenService.deleteToken();
                    if (!cancelado) navigate(redirecionar, { replace: true });
                    return;
                }

                if (!cancelado) {
                    setUsuario(dadosUsuario);
                    setAutenticado(true);
                }
            } catch {
                if (!cancelado) navigate(redirecionar, { replace: true });
            } finally {
                if (!cancelado) setCarregando(false);
            }
        };

        verificar();

        return () => { cancelado = true; };
    }, [navigate, redirecionar]);

    return { carregando, autenticado, usuario };
}

export default useAuthGuard;